import React from 'react';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import retardUpdate from '../../../lib/react/update-retarder';
import OEMediaCenterItemCollection from './components/oe-media-center-item-collection';

export default class OEMediaCenterItemCollectionController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.categoryItems = [];

        this.state = {
            categoryMediaItems: [],
            actualCategoryMediaItemIndex: -1
        };

        this.onConnect = this.onConnect.bind(this);
        this.onRelease = this.onRelease.bind(this);
        
        this.onActualMediaCenterCategoryChanged = this.onActualMediaCenterCategoryChanged.bind(this);
        this.onAddedToActualMediaCenterCategoryMediaItems = this.onAddedToActualMediaCenterCategoryMediaItems.bind(this);
        this.onRemovedFromActualMediaCenterCategoryMediaItems = this.onRemovedFromActualMediaCenterCategoryMediaItems.bind(this);
        this.onActualMediaCenterCategoryMediaItemMoved = this.onActualMediaCenterCategoryMediaItemMoved.bind(this);
        this.onActualMediaCenterItemChanged = this.onActualMediaCenterItemChanged.bind(this);
        this.onActualMediaCenterSubItemChanged = this.onActualMediaCenterSubItemChanged.bind(this);
        this.onMediaCenterItemDataChanged = this.onMediaCenterItemDataChanged.bind(this);
        
        this.onCategoryMediaItemClicked = this.onCategoryMediaItemClicked.bind(this);
    }
    
    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterCategoryChanged, this.onActualMediaCenterCategoryChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.addedToActualMediaCenterCategoryMediaItems, this.onAddedToActualMediaCenterCategoryMediaItems);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.removedFromActualMediaCenterCategoryMediaItems, this.onRemovedFromActualMediaCenterCategoryMediaItems);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterCategoryMediaItemMoved, this.onActualMediaCenterCategoryMediaItemMoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterItemChanged, this.onActualMediaCenterItemChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterSubItemChanged, this.onActualMediaCenterSubItemChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.mediaCenterItemDataChanged, this.onMediaCenterItemDataChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterCategoryChanged, this.onActualMediaCenterCategoryChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.addedToActualMediaCenterCategoryMediaItems, this.onAddedToActualMediaCenterCategoryMediaItems);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.removedFromActualMediaCenterCategoryMediaItems, this.onRemovedFromActualMediaCenterCategoryMediaItems);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterCategoryMediaItemMoved, this.onActualMediaCenterCategoryMediaItemMoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterItemChanged, this.onActualMediaCenterItemChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterSubItemChanged, this.onActualMediaCenterSubItemChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.mediaCenterItemDataChanged, this.onMediaCenterItemDataChanged);
    }

    updateCategoryItems()  {
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        this.categoryItems = controller.getActualCategoryMediaItems();

        let categoryMediaItems = [];
        for(let i = 0; i < this.categoryItems.length; i++)  {
            let itemIds = this.categoryItems[i];
            let item = controller.mediaItemIDPair(itemIds);
            if(item !== null)   categoryMediaItems.push(item);
        }

        this.setState({categoryMediaItems: categoryMediaItems});

        this.updateActualCategoryMediaItemIndex();
    }

    updateActualCategoryMediaItemIndex()    {
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        let index = controller.getActualMediaItemCategoryIndex();

        if(index >= this.categoryItems.length)   index = -1;

        this.setState({actualCategoryMediaItemIndex: index});
    }

    updateActualMediaCenterItem()   {
        this.updateActualMediaCenterSubItem();
    }

    updateActualMediaCenterSubItem()    {
        this.updateActualCategoryMediaItemIndex();
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.categoryItems = [];
            this.setState({
                categoryMediaItems: [],
                actualCategoryMediaItemIndex: -1,
            });
            return;
        }

        retardUpdate(this, () => {
            this.updateCategoryItems();
        });
    }

    onActualMediaCenterCategoryChanged(message, userInfo)    {
        this.updateCategoryItems();
    }

    onAddedToActualMediaCenterCategoryMediaItems(message, userInfo)    {
        this.updateCategoryItems();
    }

    onRemovedFromActualMediaCenterCategoryMediaItems(message, userInfo)    {
        this.updateCategoryItems();
    }

    onActualMediaCenterCategoryMediaItemMoved(message, userInfo)    {
        this.updateCategoryItems();
    }

    onActualMediaCenterItemChanged(message, userInfo)   {
        this.updateActualMediaCenterItem();
    }

    onActualMediaCenterSubItemChanged(message, userInfo)    {
        this.updateActualMediaCenterSubItem();
    }

    onMediaCenterItemDataChanged(message, userInfo)  {
        if(!(userInfo.changeFlags & this.oe.Module.MediaCenterItemDataChangeFlags.is_hidden.value)) return;
        if(this.categoryItems.findIndex((ids) => ids.id == userInfo.item && ids.subId == userInfo.subItem) < 0)    return;
        this.updateCategoryItems();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEMediaCenterItemCollection
                    {...this.props}
                    items={this.state.categoryMediaItems}
                    selectedItemIndex={this.state.actualCategoryMediaItemIndex}
                    onClick={this.onCategoryMediaItemClicked}
                />
            </React.Fragment>
        );
    }

    onCategoryMediaItemClicked(index, id, subId)   {
        if(this.oe.isReady() && (typeof(subId) === 'undefined' || subId === null || id != this.oe.sharedInterface.getUIControllerMediaCenter().getActualMediaItemID())) {
            this.oe.sharedInterface.getUIControllerMediaCenter().setActualMediaItemByCategoryIndex(index);
            if(this.props.onSelected)   this.props.onSelected(index, id, subId);
        }

        if(this.props.onClick)  this.props.onClick(index, id, subId);
    }
}

const {items: defaultItems, selectedItemIndex: defaultSelectedItemIndex, ...restDefaults} = OEMediaCenterItemCollection.defaultProps;
const {items: propTypesItems, selectedItemIndex: propTypesSelectedItemIndex, ...restPropTypes} = OEMediaCenterItemCollection.propTypes;

OEMediaCenterItemCollectionController.defaultProps = restDefaults;

OEMediaCenterItemCollectionController.propTypes = restPropTypes;

